import { Button, Form, Offcanvas } from "react-bootstrap";
import { subCategoryServices } from "../../../APIServices/DiscoveryControls/subCategoryServices";
import { useEffect, useState } from "react";
import { categoryServices } from "../../../APIServices/DiscoveryControls/categoryServices";

const AddNewDiscoverySubCategory = ({ Show, Hide, Title, getDiscoverySubCategoryList }) => {
  const [loader, setLoader] = useState(false);

  const [name, setName] = useState("");
  const [categoryId, setCategoryId] = useState("");
  const [categoryList, setCategoryList] = useState([]);

  const addNewDiscoverySubCategory = async () => {
    setLoader(true);
    const userData = {
      name,
      categoryId
    };
    const data = await subCategoryServices.addNewDiscoverySubCategory(userData);
    if (data?.statusCode === 200) {
      setName("");
      setCategoryId("");
      getDiscoverySubCategoryList();
      Hide();
    }
    setLoader(false);
  };

  const getDiscoveryCategoryList = async () => {
    let data = await categoryServices.getDiscoveryCategoryList(
      "active",
    );
    setCategoryList(data?.data || []);
  };

  useEffect(() => {
    if(Show){
      getDiscoveryCategoryList();
    }
  }, [Show]);

  return (
    <Offcanvas show={Show} onHide={Hide} placement="end">
      <Offcanvas.Header closeButton className="bg-light p-3 border-bottom">
        <Offcanvas.Title className="fw-bold" style={{ fontSize: 15 }}>
          {Title}
        </Offcanvas.Title>
      </Offcanvas.Header>
      <Offcanvas.Body>
        <Form.Group className="mb-2">
          <Form.Label className="fw-bold mb-1" style={{ fontSize: 13 }}>
            Category
          </Form.Label>
          <Form.Select
            className="interactive-input"
            value={categoryId}
            onChange={(e) => setCategoryId(e.target.value)}
            style={{ fontSize: 12, padding: "6px 15px" }}
          >
            <option value="">Select Category</option>
            {categoryList?.map((item, index) => (
              <option key={index} value={item?.categoryId}>{item?.name}</option>
            ))}
          </Form.Select>
        </Form.Group>
        <Form.Group className="mb-2">
          <Form.Label className="fw-bold mb-1" style={{ fontSize: 13 }}>
            Name
          </Form.Label>
          <Form.Control
            value={name}
            onChange={(e) => setName(e.target.value)}
            placeholder="Enter Name"
            style={{ fontSize: 12 }}
          />
        </Form.Group>
      </Offcanvas.Body>
      <div className="text-end p-2 border-top bg-light">
        <Button
          disabled={!name || !categoryId || loader}
          onClick={addNewDiscoverySubCategory}
          variant="outline-primary"
          style={{ fontSize: 13 }}
          className="rounded-2 py-1 px-3"
        >
          {loader ? "Saving..." : Title}
        </Button>
      </div>
    </Offcanvas>
  );
};

export default AddNewDiscoverySubCategory;